/**
 *
 * Asynchronously loads the component for ForgotPage
 *
 */

import loadable from 'loadable-components';

export default loadable(() => import('./index'));
